import { LineGraphData } from './linegraphData';

export class PerspectiveGraphValue {
    public dayOfWeek: number;
    public bestGuess: LineGraphData[];
    public optimistic: LineGraphData[];
    public pesimistic: LineGraphData[];

    constructor(json?: any) {
        if (json) {
            this.dayOfWeek = json.dayOfWeek;
            this.bestGuess = json.bestGuess.map((data: any) => new LineGraphData(data));
            this.optimistic = json.optimistic.map((data: any) => new LineGraphData(data));
            this.pesimistic = json.pesimistic.map((data: any) => new LineGraphData(data));
        }
    }
}

export class PerspectiveGraphData {
    public data: any;
    public label: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/perspectiveGraphValue.ts